import { useState } from 'react'
import { Box, CircularProgress } from '@mui/material'
import { Modal, Button } from 'Common/Supplyvue-ui'
import { ConstrainingHorizonsTable } from './ConstrainingHorizonsTable'
import { ConstrainingHorizonsModalProps } from './ConstrainingHorizonsModal.types'
import { WorkcentreTableRow } from '../utils/planHelpers'

export const ConstrainingHorizonsModal = ({
  isOpen,
  onClose,
  onSave,
  tableData,
  planStartWeek,
  isLoading = false,
}: ConstrainingHorizonsModalProps) => {
  const handleDataChange = (updatedData: WorkcentreTableRow[]) => {
    onSave(updatedData)
  }

  const handleSave = () => {
    handleClose()
  }

  const handleClose = () => {
    onClose()
  }

  const Body = (
    <Box
      className="constraining-horizons-modal-body"
      sx={{
        marginTop: 2,
        //minWidth: '80%',
        maxWidth: '80vw',
      }}
    >
      <ConstrainingHorizonsTable
        data={tableData}
        onDataChange={handleDataChange}
        planStartWeek={planStartWeek}
      />
    </Box>
  )

  const Footer = (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        justifyContent: 'flex-end',
        gap: 2,
      }}
    >
      <Button onClick={handleClose} variant="outlined" disabled={isLoading}>
        Cancel
      </Button>
    </Box>
  )

  return (
    <Modal
      open={isOpen}
      handleClose={handleClose}
      onClose={handleClose}
      header="Update constraining horizons"
      body={Body}
      footer={Footer}
      isHeaderCloseButtonDisabled={isLoading}
    />
  )
}
